module.exports = __webpack_public_path__ + "static/media/savings-icon.180d1356.svg";